import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { siteMeta } from '../seo/siteMeta';

const PageContainer = styled.main`
  padding-top: 110px;
  min-height: 100vh;
  background: linear-gradient(135deg, #1A365D 0%, #0B1D3A 100%);
  color: var(--white);
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem var(--spacing-md) 4rem;
`;

const Title = styled.h1`
  margin-bottom: var(--spacing-md);
  color: var(--white);
`;

const Text = styled.p`
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.8;
  margin-bottom: var(--spacing-md);
`;

const LinkRow = styled.div`
  display: flex;
  gap: var(--spacing-md);
  flex-wrap: wrap;
`;

const PageLink = styled(Link)`
  color: var(--accent);
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const NotFound = () => {
  const seo = siteMeta.routeSeo.notFound;

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        path={seo.path}
        noindex
      />
      <PageContainer>
        <Content>
          <Title>Page Not Found</Title>
          <Text>
            The requested page does not exist. Use the main navigation to access XADevs company pages,
            products, support, and legal resources.
          </Text>
          <LinkRow>
            <PageLink to="/">Home</PageLink>
            <PageLink to="/#products">Products</PageLink>
            <PageLink to="/#about">About</PageLink>
            <PageLink to="/#contact">Contact</PageLink>
            <PageLink to="/support">Support</PageLink>
          </LinkRow>
        </Content>
      </PageContainer>
    </>
  );
};

export default NotFound;
